export default __webpack_public_path__ + "static/media/svelte.aa77c56a.svg";